<script setup lang="ts">
import type { Ref } from 'vue'

import { useRegisterSW } from 'virtual:pwa-register/vue'

export interface ReloadPromptProps {
  // Holds Application name. E.g. Brandefense or ExampleCompany
  appName: string
}

defineProps<ReloadPromptProps>()

const { t } = useI18n()

const { needRefresh, updateServiceWorker } = useRegisterSW()

const loading: Ref<boolean> = ref(false)

/**
 * @name close
 * @description Resets the loading and needRefresh states.
 * @returns {Promise<void>} A promise that resolves when the states are reset.
 */
async function close(): Promise<void> {
  loading.value = false
  needRefresh.value = false
}

/**
 * @name update
 * @description Updates the service worker and manages the loading state during the update process.
 * @returns {Promise<void>} A promise that resolves when the update process is complete.
 */
async function update(): Promise<void> {
  loading.value = true
  await updateServiceWorker()
  loading.value = false
}
</script>

<template>
  <Transition name="from-bottom">
    <Card v-if="false" class="pwa-toast">
      <div class="pwa-message">
        <span class="body-3">
          {{ t('reload-prompt.need-refresh', { appName }) }}
        </span>
      </div>
      <Flex justify-content="end" column-gap="0.5rem">
        <Button color="slate" :text="t('reload-prompt.close-button')" @click="close" />
        <Button
          v-if="needRefresh"
          color="primary"
          :loading="loading"
          :text="t('reload-prompt.reload-button')"
          @click="update"
        />
      </Flex>
    </Card>
  </Transition>
</template>

<style lang="scss" scoped>
// Styles removed - not needed in lite edition
</style>
